import axios from '../../axios'

/**
 * todo 获取用户订单列表
 * @param {orderFlag: 默认0为全部 ，1为待付款，2为待发货，3为已付款，4为已超时, pageNo: 页码默认1, pageSize: 每页数量默认20}
 */
export function getOrderList(params, config) {
  return axios.get(`/goods/getOrderList`, params, config)
}

/**
 * todo 超时订单移除
 * @param {orderId: 订单id}
 */
export function overTimeOrderDelete(params) {
  return axios.get(`/goods/overTimeOrderDelete`, params)
}

/**
 * todo 取消支付商品订单
 * @param {orderId: 订单id}
 */
export function cancelPayOrder(params) {
  return axios.get(`/goods/cancelPayOrder`, params)
}

/**
 * todo 取消商品订阅
 * @param {orderId: 订单id}
 */
export function cancelOrderRetailGoods(params) {
  return axios.get(`/goods/cancelOrderRetailGoods`, params)
}

/**
 * todo 提醒发货
 * @param {orderId: 订单id}
 */
export function remindSendOutGoods(params) {
  return axios.get(`/goods/remindSendOutGoods`, params)
}

/**
 * todo 取消订单
 * @param {orderId: 订单id}
 */
export function cancelOrder(params) {
  return axios.post(`/weixin/cancel/order`, params)
}
